export default __webpack_public_path__ + "static/media/image_05.711211e7.jpg";